import { render, staticRenderFns } from "./news-info-cn.vue?vue&type=template&id=578b6a50&"
import script from "./news-info-cn.vue?vue&type=script&lang=js&"
export * from "./news-info-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports